import React, { useState, useEffect } from 'react';
import fetchCourseIntegrations from '../../../services/fetchCourseIntegrations';
import ButtonContainer from '../../../components/ButtonContainer';
import user from '../../../store/user';
import fetchCourseList from '../../../services/fetchCourseList';
import './styles.scss';
import { Header, Modal, Table } from 'semantic-ui-react';
import Loader from '../../../components/Loader';
import CountDisplay from '../../../components/CountDisplay';
import Pagination from '../../../components/Pagination';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import { getQueryParams } from "../../../utils/utilFunctions";
import { Link } from 'react-router-dom';
import deleteCourse from '../../../services/deleteCourse';
import unpublishCourse from '../../../services/unpublishCourse';
import rejectCourse from '../../../services/rejectCourse';
import deleteCourseBrochure from '../../../services/deleteCourseBrochure';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { rejectReasonsCourse } from '../../../models/rejectReasonsCourse';
import FromToDatepicker from '../../../components/FromToDatepicker';
import fetchLeadsByIntegrations from '../../../services/fetchLeadsByIntegrations';
import generateTestLead from '../../../services/generateTestLead';


const PAGE_CONTENT = 50;


const CourseList = (props) => {

    const [content, setContent] = useState({
        list: [],
        count: 0,
        pageNumber: 1
    })

    const [admin, setAdmin] = useState({
        adminId: null,
    })

    const [fetchApiCall, setFetchApiCall] = useState(true)

    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [modalCourseId, setModalCourseId] = useState(null);
    const [rejectData, setRejectData] = useState({
        reasonId: '',
        rejectMsg: ''
    })

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // Integration filter state
    const [integration, setIntegration] = useState('0');
    const [courseIntegrations, setCourseIntegrations] = useState({
        list: [],
        map: {}
    });

    const [courseCounts, setCourseCounts] = useState({
        liveCoursesCount: 0,
        publishedCoursesCount: 0,
        unpublishedCoursesCount: 0,
    });

    const [leadsCount, setLeadsCount] = useState(null);

    // Course ID for lead generation
    const [courseIdInput, setCourseIdInput] = useState('');

    const handleCourseIdChange = (e) => {
        // Only allow integer values
        const value = e.target.value.replace(/\D/g, '');
        setCourseIdInput(value);
    };

    const handleGenerateLead = async () => {
        if (!courseIdInput) {
            toast.error('Please enter a Course ID');
            return;
        }

        try {
            setFetchApiCall(true);
            await generateTestLead(admin.adminId, { courseId: courseIdInput });
            toast.success('Lead generated successfully');
            setFetchApiCall(false);
        } catch (error) {
            console.log(error);
            toast.error('Failed to generate lead');
            setFetchApiCall(false);
        }
    };

    useEffect(() => {

        const fetchProfile = async () => {
            return await user.getProfile()
        }
        fetchProfile().then(userData => {
            if (userData.adminType == 2 || userData.adminType == 3 || userData.adminType == 4) {
                setAdmin({
                    adminId: userData.id,
                })
                const queryObj = getQueryParams(props.location.search);
                setContent(prev => ({
                    ...prev,
                    pageNumber: queryObj.pageNumber,
                }));
                let integrationValue = queryObj.integration ? queryObj.integration : '0';
                setIntegration(integrationValue);
                const startDateValue = queryObj.startDate || null;
                const endDateValue = queryObj.endDate || null;
                setStartDate(startDateValue);
                setEndDate(endDateValue);
                getCourseInterations(userData.id);
                const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

                getCourseList(userData.id, pgNo, integrationValue, startDateValue, endDateValue);
            } else {
                window.location.href = process.env.REACT_APP_LOGIN_URL;
            }
        });
    }, []);

    // Fetch integration types
    const getCourseInterations = async (adminId) => {
        try {
            const res = await fetchCourseIntegrations(adminId);
            const data = res.data.data.integrations;
            const formattedList = formatIntegration(data);

            setCourseIntegrations({
                list: formattedList,
                map: data
            });
        }
        catch (e) {
            console.log(e);
            toast.error('Something went wrong!');
        }
    }

    const formatIntegration = (listMap) => {
        const newList = [];
        newList.push({
            id: '0',
            name: 'Select Integration Type'
        })
        for (const key in listMap) {
            newList.push({
                id: key,
                name: listMap[key]
            })
        }
        return newList;
    }


    // Accept filters for integration
    const getCourseList = async (adminId, pageNumber, integrationValue, startDate, endDate) => {
        setFetchApiCall(true);
        try {
            const filters = {};
            if (startDate) {
                filters.startDate = startDate;
            }
            if (endDate) {
                filters.endDate = endDate;
            }
            if (integrationValue) {
                filters.integration = integrationValue;
            }
            routeRequest(pageNumber, integrationValue, startDate, endDate);
            const leads = await fetchLeadsByIntegrations(adminId, integrationValue, { startDate, endDate });
            setLeadsCount(leads.data.data.totalLeads);

            const res = await fetchCourseList(adminId, { page: pageNumber, pageSize: PAGE_CONTENT, ...filters });
            setContent({
                pageNumber: pageNumber,
                list: res.data.data.data,
                count: res.data.data.totalCount,
            });
            setCourseCounts({
                liveCoursesCount: res.data.data.liveCoursesCount,
                publishedCoursesCount: res.data.data.publishedCoursesCount,
                unpublishedCoursesCount: res.data.data.unpublishedCoursesCount,
            });
            setFetchApiCall(false)
        }
        catch (err) {
            console.log(err);
            toast.error('Failed to fetch course list.');
            setFetchApiCall(false)
        }
    }


    const handlePageChange = async (n) => {
        await getCourseList(admin.adminId, n, integration, startDate, endDate);
    }


    const routeRequest = (pageNumber, integration, startDate, endDate) => {
        let array = [];
        array.push(`pageNumber=${pageNumber}`);
        if (integration >= 0) {
            array.push(`integration=${integration}`);
        }
        if (startDate) {
            array.push(`startDate=${startDate}`);
        }
        if (endDate) {
            array.push(`endDate=${endDate}`);
        }
        array = array.join("&");
        props.history.push("?" + array);
    };
    // Integration filter change handler
    const onChangeFilter = async (event) => {
        const newIntegration = event.target.value;
        setIntegration(newIntegration);
        await getCourseList(admin.adminId, 1, newIntegration, startDate, endDate);
    }

    const handleChangeStart = async (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        setStartDate(formattedDate);
        await getCourseList(admin.adminId, 1, integration, formattedDate, endDate);
    }

    const handleChangeEnd = async (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        setEndDate(formattedDate);
        await getCourseList(admin.adminId, 1, integration, startDate, formattedDate);
    }

    const delCourse = async (e, courseId) => {
        e.preventDefault();
        if (window.confirm('Are you sure to delete this Course ? ')) {

            try {
                setFetchApiCall(true);
                await deleteCourse(admin.adminId, courseId);
                toast.info('Course deleted successfully');

                const queryObj = getQueryParams(props.location.search);
                const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

                await getCourseList(admin.adminId, pgNo, integration, startDate, endDate)
                setFetchApiCall(false);


            } catch (e) {
                setFetchApiCall(false);
                toast.error('Course could not be deleted');
            }
        }
    }

    const unpubCourse = async (e, courseId) => {
        e.preventDefault();
        if (window.confirm('Are you sure to unpublish this Course ? ')) {

            try {
                setFetchApiCall(true);
                await unpublishCourse(admin.adminId, courseId);
                toast.info('Course unpublished successfully');

                const queryObj = getQueryParams(props.location.search);
                const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

                await getCourseList(admin.adminId, pgNo, integration, startDate, endDate)
                setFetchApiCall(false);


            } catch (e) {
                setFetchApiCall(false);
                toast.error('Course could not be unpublished');
            }
        }
    }

    const onClickRejectButton = async () => {
        try {
            // if(!rejectData.reasonId || !rejectData.rejectMsg) {
            //     alert('Please enter a reason! ')
            //     return;
            // }
            if (!rejectData.reasonId) {
                alert('Please enter a reason! ')
                return;
            }
            setFetchApiCall(true);
            const data = {
                courseId: modalCourseId,
                reason: rejectData.rejectMsg
            }
            await rejectCourse(admin.adminId, data);
            toast.info('Course rejected successfully');

            const queryObj = getQueryParams(props.location.search);
            const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

            setIsRejectModalOpen(false);
            setRejectData({
                reasonId: '',
                rejectMsg: ''
            })

            await getCourseList(admin.adminId, pgNo, integration, startDate, endDate);
            setFetchApiCall(false);

        } catch (e) {
            setFetchApiCall(false);
            toast.error('Course could not be rejected');
        }
    }

    const rejCourse = (e, courseId) => {
        e.preventDefault();
        setModalCourseId(courseId);
        setIsRejectModalOpen(true);
    }

    const delBrochure = async (e, courseId, recId) => {
        e.preventDefault();
        if (window.confirm('Are you sure to delete this Course Brochure? ')) {

            try {
                setFetchApiCall(true);
                await deleteCourseBrochure(admin.adminId, {
                    courseId,
                    recId
                });
                toast.info('Course Brochure deleted successfully');

                const queryObj = getQueryParams(props.location.search);
                const pgNo = queryObj.pageNumber ? queryObj.pageNumber : 1;

                await getCourseList(admin.adminId, pgNo, integration, startDate, endDate);
                setFetchApiCall(false);


            } catch (e) {
                setFetchApiCall(false);
                toast.error('Course Brochure could not be deleted');
            }
        }
    }

    const rejectDropdownChange = (event) => {
        var rejectJobReasonSelect = rejectReasonsCourse.filter((eachReason) => { if (eachReason.id == event.target.value) return true; return false; })
        setRejectData({ rejectMsg: rejectJobReasonSelect[0].msg, reasonId: event.target.value })
        // setRejectData({ rejectMsg: '' , reasonId: event.target.value })
    }

    const onModalClose = () => {
        setIsRejectModalOpen(false);
        setModalCourseId(null);
        setRejectData({
            reasonId: '',
            rejectMsg: ''
        })
    }

    const rejectReasonChange = (e) => {
        const value = e.target.value;
        setRejectData(prev => ({
            ...prev,
            rejectMsg: value
        }))
    }

    return (
        <div className="course-list-wrapper">
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable={false}
                pauseOnHover
            />

            <div className="course-list-heading">
                <Heading text="Course" />
                <Button skin='dark' className="btn_post_course" text="Post Course" clickButton={() => { props.history.push('/addCourse') }} />
                {/* <a href='/courseMappingList'>
                    <Button  skin='dark' className="btn_course_mapping" text="Course Mapping" clickButton={() => { props.history.push('/courseMappingList?pageNumber=1') }}  />
                </a> */}
                <Button skin='dark' className="btn_course_mapping" text="Course Mapping" clickButton={() => { props.history.push('/courseMappingList?pageNumber=1') }} />

                <a href={`${process.env.REACT_APP_CLIENT_URL}/recruiter/course_admin_new.php`} target='_blank'>
                    <Button skin='dark' className="btn_use_old" disabled={false} text='Use Old Version' />
                </a>

            </div>

            {/* Integration Type Dropdown Filter */}
            <div className="row">
                <ButtonContainer heading="Filter by: ">
                    <li key="filter">
                        <label>Integration Type</label>
                        <Dropdown
                            data={courseIntegrations.list}
                            dropdownChange={onChangeFilter}
                            defaultValue={integration}
                        />
                    </li>
                    <li key="date-filter">
                        <label>Date</label>
                        <FromToDatepicker startDate={startDate ? moment(startDate, 'YYYY-MM-DD').toDate() : null} endDate={endDate ? moment(endDate, 'YYYY-MM-DD').toDate() : null} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} />
                    </li>
                    <li key="course-id-filter" className="course-id-filter">
                        <label>Course ID</label>
                        <div className="course-id-input-wrapper">
                            <input
                                type="text"
                                placeholder="Enter Course ID"
                                value={courseIdInput}
                                onChange={handleCourseIdChange}
                                className="course-id-input"
                            />
                            <Button
                                skin='dark'
                                className="btn_generate_lead"
                                text="Generate Lead"
                                clickButton={handleGenerateLead}
                            />
                        </div>
                    </li>
                </ButtonContainer>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <p>
                        Live Courses: <strong>{courseCounts.liveCoursesCount}</strong>,
                        Published Courses: <strong>{courseCounts.publishedCoursesCount}</strong>,
                        Unpublished Courses: <strong>{courseCounts.unpublishedCoursesCount}</strong>
                        {leadsCount !== null && (
                            <> ,Total Leads: <strong>{leadsCount}</strong></>
                        )}
                    </p>
                </div>
            </div>

            <div className="row text-center">
                <Pagination
                    totalItemsCount={content.count}
                    content={PAGE_CONTENT}
                    pageNumber={content.pageNumber}
                    handlePageChange={(n) => handlePageChange(n)} />
                <CountDisplay start={(content.pageNumber - 1) * PAGE_CONTENT + 1} end={content.pageNumber * PAGE_CONTENT} total={content.count} />

                {fetchApiCall ? (
                    <Loader />
                ) : (
                    content.list.length ? (
                        <div className="content">
                            <Table
                                fixed
                                selectable
                                className="mailers-table"
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={3}>
                                            Date
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            Live Date
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={4}>
                                            Title
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            Hits/ Applied
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            Actions
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            Recruiter
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={3}>
                                            Display Location <br />
                                            Main Website/ Mobile App/ Similar Jobs Web/ Similar Jobs Mobile
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {content.list.map((item, i) => {
                                        return (
                                            <Table.Row>
                                                <Table.Cell>
                                                    {moment(item.date).format('DD-MM-YYYY hh:mm a')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(item.publishedOn).isValid() ? moment(item.publishedOn).format('DD-MM-YYYY hh:mm a') : 'N/A'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Link to={`/addCourse?courseId=${item.id}&publishedId=${item.publishedId}`}>{`${item.title} `}</Link>
                                                    {item.isPremium ? '[Premium]' : null} <br />
                                                    {`Published Id: ${item.publishedId}`}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {`${item.hits} Hits`} <br />
                                                    {
                                                        item.publishedId ? (
                                                            <Link to={`/courseEnquiry?courseId=${item.publishedId}`}>View Leads </Link>
                                                        ) : 'View Leads'
                                                    }
                                                    ({item.leadsCount})
                                                    <br />
                                                    {
                                                        item.publishedId ? (
                                                            <Link to={`/courseEnquiry?courseId=${item.publishedId}&type=relevant`}>View Relevant Leads </Link>
                                                        ) : 'View Relevant Leads'
                                                    }
                                                    ({item.relevantLeadsCount})
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {item.status}
                                                    {item.lastUpdated == 1 ? ' (But Updated)' : null} <br />
                                                    {
                                                        item.isPublished ? (
                                                            <>
                                                                <a href="" onClick={(e) => delCourse(e, item.id)} >Delete</a> <br />
                                                                <a href="" onClick={(e) => unpubCourse(e, item.id)}>Unpublish</a>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <a href="" onClick={(e) => delCourse(e, item.id)}>Delete</a> <br />
                                                                {
                                                                    !item.isRejected ? (
                                                                        <a href="" onClick={(e) => rejCourse(e, item.id)}>Reject</a>
                                                                    ) : null
                                                                }
                                                            </>

                                                        )

                                                    }


                                                </Table.Cell>
                                                <Table.Cell>
                                                    {item.email} <br />
                                                    <a target='_blank' href={`${process.env.REACT_APP_CLIENT_URL}/r/${item.recId}-${item.recName}`}>View Profile</a> <br />
                                                    <Link to={`/changeCourseRecruiter?courseId=${item.id}`}>Change Recruiter</Link> <br />
                                                    {
                                                        item.brochureFile ? (
                                                            <a href="" onClick={(e) => delBrochure(e, item.id, item.recId)}>Delete Brochure File</a>
                                                        ) : null
                                                    }
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {item.web}/ {item.mobApp}/ {item.similarWeb}/ {item.simMob} <br />
                                                    Redirected: {item.redirected}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>

                            <Modal open={isRejectModalOpen} onClose={onModalClose} >
                                <Header content='Why Rejected' />
                                <Modal.Content>
                                    <div className='modal-content'>
                                        <div className='modal-subcontent'>
                                            <label className='modal-label'>Select Reason</label>
                                            <Dropdown dropdownChange={rejectDropdownChange} className='modal-dropdown' name='rejectJob' data={rejectReasonsCourse} />
                                        </div>
                                        <div className='modal-subcontent'>
                                            <label className='modal-label'> Enter Reason</label>
                                            <textarea value={rejectData.rejectMsg} rows='5' maxLength='300' onChange={rejectReasonChange}>
                                            </textarea>
                                        </div>
                                        <div className='modal-subcontent'>
                                            Max 300 characters
                                        </div>
                                    </div>
                                </Modal.Content>

                                <Modal.Actions>
                                    <Button text='Reject' skin='light' clickButton={onClickRejectButton} />
                                    <Button text='Close' skin='light' clickButton={onModalClose} />
                                </Modal.Actions>
                            </Modal>
                        </div>
                    ) : (
                        <div>
                            No Records Found
                        </div>
                    )

                )
                }
            </div>
        </div>
    );
};

export default CourseList;
